export default __webpack_public_path__ + "static/media/Dotimatrix-5.ttf.4c8e6b0c.woff";